import { FetchListPayload } from '../actions/fetchList';
import { PayloadApiRequest } from '../actions/sagaApi';

import appointmentsResource from './appointmentsResource';
import createResource, { OptionalResource } from './createResource';
import patientFormTemplatesResource from './patientFormTemplatesResource';
import patientsResource from './patientsResource';
import usersResource from './usersResource';
import { EntityID, PatientForm } from './types';

const patientFormsResource = createResource<PatientForm>({
  key: 'patientForms',
  url: '/patientForms',
  lookups: {
    patientFormTemplate: patientFormTemplatesResource,
    patient: patientsResource,
    appointment: appointmentsResource,
    processingStatusUpdatedBy: usersResource,
  },
});

const customActions = {
  medicationSearch: (
    payload: OptionalResource<FetchListPayload<PatientForm>> & {
      params: { search: string; [param: string]: any };
    },
  ) =>
    patientFormsResource.fetchList({
      url: `${patientFormsResource.url}/medicationsearch`,
      ...payload,
    }),
  ccdaMedicationSearch: (
    payload: OptionalResource<FetchListPayload<PatientForm>> & {
      params: { search: string; [param: string]: any };
    },
  ) =>
    patientFormsResource.fetchList({
      url: `${patientFormsResource.url}/ccdasearch?type=medications`,
      ...payload,
    }),
  ccdaAllergySearch: (
    payload: OptionalResource<FetchListPayload<PatientForm>> & {
      params: { search: string; [param: string]: any };
    },
  ) =>
    patientFormsResource.fetchList({
      url: `${patientFormsResource.url}/ccdasearch?type=allergies`,
      ...payload,
    }),
  ccdaImmunizationHistory: (
    payload: OptionalResource<FetchListPayload<PatientForm>> & {
      params: { search: string; [param: string]: any };
    },
  ) =>
    patientFormsResource.fetchList({
      url: `${patientFormsResource.url}/ccdasearch?type=immunizations`,
      ...payload,
    }),
  ccdaSurgicalHistory: (
    payload: OptionalResource<FetchListPayload<PatientForm>> & {
      params: { search: string; [param: string]: any };
    },
  ) =>
    patientFormsResource.fetchList({
      url: `${patientFormsResource.url}/ccdasearch?type=procedures`,
      ...payload,
    }),
  ccdaFamilyHistory: (
    payload: OptionalResource<FetchListPayload<PatientForm>> & {
      params: { search: string; [param: string]: any };
    },
  ) =>
    patientFormsResource.fetchList({
      url: `${patientFormsResource.url}/ccdasearch?type=problems`,
      ...payload,
    }),
  pharmacySearch: (
    payload: OptionalResource<FetchListPayload<PatientForm>> & {
      params: { search: string; [param: string]: any; latitude: number; longitude: number };
    },
  ) =>
    patientFormsResource.fetchList({
      url: `${patientFormsResource.url}/pharmacysearch`,
      ...payload,
    }),
  execScript: (patientFormId: EntityID, itemId: EntityID, payload: PayloadApiRequest<PatientForm> | undefined = {}) =>
    patientFormsResource.request({
      method: 'post',
      url: `${patientFormsResource.url}/${patientFormId}/script/${itemId}`,
      ...payload,
      meta: {
        skipMessages: true,
        ...payload.meta,
      },
    }),
};

export default {
  ...patientFormsResource,
  ...customActions,
};
